import React, { useState } from "react";
import { MdAdd } from "react-icons/md";
import { toast } from "react-toastify";
import { useAddDealerMutation } from "../../features/api/dealerApi";

const NewClient = () => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => {
    setIsOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setIsOpen(false);
    document.body.style.overflow = "auto";
  };

  const [addNewDealer] = useAddDealerMutation();

  const [d_name, setName] = useState("");
  const [d_email, setEmail] = useState("");
  const [d_address, setAddress] = useState("");
  const [d_addressing, setAddressing] = useState("");
  const [d_phone, setPhone] = useState("");
  const [d_mobile, setMobile] = useState("");
  const [d_web, setWeb] = useState("");
  const handleAdd = async () => {
    try {
      const newDealer = {
        d_name,
        d_email,
        d_address,
        d_addressing,
        d_phone,
        d_mobile,
        d_web,
      };
      const result = await addNewDealer(newDealer);

      if (result) {
        setIsOpen(false);
        document.body.style.overflow = "auto";
        toast.success("Dealer create success...!!!");

        setName("");
        setEmail("");
        setAddress("");
        setPhone("");
        setMobile("");
        setWeb("");
      }
    } catch (error) {
      console.error("Error updating data:", error);
    }
  };
  return (
    <div>
      <span
        onClick={openModal}
        className=" px-2 py-1 text-white bg-blue-500 cursor-pointer flex items-center rounded"
      >
        <MdAdd size={25} /> New Client
      </span>

      {isOpen && (
        <div className="fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded shadow-md md:w-[600px]">
            <button
              className="text-red-500 font-bold float-right"
              onClick={closeModal}
            >
              X
            </button>
            <div className="card bg-base-100 overflow-auto mt-4">
              <div className="card-body">
                <div className="text-center">
                  <h2 className=" font-bold">Add New Client</h2>
                </div>
                <div
                  className="flex flex-col items-start font-extralight p-4"
                  style={{ lineHeight: "30px" }}
                >
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 overflow-auto w-full">
                    <input
                      type="text"
                      value={d_name}
                      onChange={(e) => setName(e.target.value)}
                      className="border pl-1 focus:outline-none font-bold"
                      placeholder="Name"
                    />
                    <input
                      type="email"
                      value={d_email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="border pl-1 focus:outline-none font-bold"
                      placeholder="Email"
                    />

                    <input
                      type="text"
                      value={d_phone}
                      onChange={(e) => setPhone(e.target.value)}
                      className="border pl-1 focus:outline-none font-bold"
                      placeholder="Phone"
                    />
                    <input
                      type="text"
                      value={d_mobile}
                      onChange={(e) => setMobile(e.target.value)}
                      className="border pl-1 focus:outline-none font-bold"
                      placeholder="Mobile"
                    />
                    <input
                      type="text"
                      value={d_web}
                      onChange={(e) => setWeb(e.target.value)}
                      className="border pl-1 focus:outline-none font-bold"
                      placeholder="Website"
                    />
                  </div>
                  <div className="w-full mt-2">
                    <input
                      type="text"
                      value={d_address}
                      onChange={(e) => setAddress(e.target.value)}
                      className="border pl-1 focus:outline-none font-bold w-full mb-2"
                      placeholder="Address"
                    />
                    <input
                      type="text"
                      value={d_addressing}
                      onChange={(e) => setAddressing(e.target.value)}
                      className="border pl-1 focus:outline-none w-full font-bold"
                      placeholder="Addressing"
                    />
                  </div>
                  <button
                    onClick={() => handleAdd()}
                    className="bg-green-500 text-white font-bold mt-6 px-4 block m-auto"
                  >
                    Add
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default NewClient;
